var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 23.4,
    height: 23.4,
    rx: 11.7,
    fill: "#FF0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 23.4,
    height: 23.4,
    rx: 11.7,
    stroke: "#FF0000",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4906 8.66875C17.1656 8.09062 16.8125 7.98438 16.0906 7.94375C15.375 7.89375 13.5656 7.875 12 7.875C10.4313 7.875 8.625 7.89375 7.90625 7.94375C7.1875 7.98438 6.83438 8.09062 6.50625 8.67188C6.17188 9.24688 6 10.2437 6 11.9969V12V12.0031V12.0062C6 13.7531 6.17188 14.7562 6.50625 15.3281C6.83438 15.9062 7.1875 16.0125 7.90625 16.0594C8.625 16.1 10.4313 16.125 12 16.125C13.5656 16.125 15.3719 16.1 16.0906 16.0594C16.8094 16.0094 17.1625 15.9062 17.4875 15.3281C17.8281 14.7531 18 13.75 18 12.0031V12C18 12 18 12 18 11.9969C18 10.2437 17.8281 9.24688 17.4906 8.66875ZM10.5 14.25V9.75L14.25 12L10.5 14.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.f0a8b1a8428c86713058e2740d06e310.svg";
export { ForwardRef as ReactComponent };